import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJMobileRecognition from './FJMobileRecognition';
import FJActionTextToImage from '../../../redux/action/FJActionTextToImage';
import FJTextToImageConstant from '../../../constants/FJTextToImageConstant';
import useLocalStore from '../../../hooks/useLocalStore';

const FJMobileRecognitionContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const curGeneratingPromptImageUrl = useSelector(state => state.textToImage.curGeneratingPromptImageUrl);
    const promptStatus = useSelector(state => state.textToImage.promptStatus);
    const onCancel = useCallback(() => {
        if (promptStatus === FJTextToImageConstant.IMAGE_IMPORTING) {
            dispatch(FJActionTextToImage.cancelImageRecognitionAction());
        } else {
            dispatch(FJActionTextToImage.cancelAiOptimizingAction());
        }
    }, [dispatch, promptStatus]);

    return (
        <FJMobileRecognition promptStatus={promptStatus} imageUrl={curGeneratingPromptImageUrl} onCancel={onCancel} />
    );
};
export default FJMobileRecognitionContainer;
